<template>
	<div>

		<v-toolbar flat fixed>
            <v-toolbar-title style="margin:auto;">App Update Available</v-toolbar-title>
        </v-toolbar>
		
		<div class="hasToolbar">

			<v-card flat style="max-width:420px;margin:auto;">
				<v-card-text center-align>
                    <div class="pt-2 pb-4 pr-2 pl-2" style="font-size:1.25rem;">Please update your BizOps App<br>from <span font-medium>Google Play</span> as we have made some improvements to enhance your experience.</div>
					<div><v-btn color="primary" @click="fn_openPlayStore">Update Now</v-btn></div>
				</v-card-text>
			</v-card>
            
		</div>
	</div>
</template>

<script>
	export default{
		methods:{
            fn_openPlayStore: function(){
                this.getData("OpenPlayStore", null, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            }
		},
		mounted: function(){
            window.js_globals.fn_onBackPress = this.exitApp;
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/appupdate.vue